import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import AnimatedRoutes from './AnimatedRoutes'

const AppRoutes = ({visible, setVisible}) => {
    return (
        <BrowserRouter>
            <AnimatedRoutes visible={visible} setVisible={setVisible} />
        </BrowserRouter>
    )
}

export default AppRoutes